import React, { Component } from 'react'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { setPageTitle } from '../../../utils'

export const query = graphql`
  fragment Meta on MarkdownRemark {
    frontmatter {
      meta {
        title
        description
        noindex
        canonicalLink
      }
    }
  }
`

export default class Meta extends Component {
  render() {
    const {
      title,
      url,
      description,
      absoluteImageUrl = '',
      twitterSiteAccount,
      twitterCreatorAccount,
      noindex,
      canonicalLink,
      siteTitle,
      siteDescription,
      googleTrackingId,
      defaultTitle,
      ogimage,
      alternateOgImage

      // overwrite { title, description } if in fields or fields.meta
    } = this.props

    const ogImageLink = `${process.env.GATSBY_SITE_URL}${ogimage || alternateOgImage || '/notfound.png'
      }`

    return (
      <Helmet htmlAttributes={{ lang: 'en-US' }} title={title}>
        {title && setPageTitle(title)}
        <meta name="title" content={title} />
        <meta property="og:title" content={title} />
        <meta name="twitter:title" content={title} />
        <meta property="og:site_name" content={title} />
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta name="twitter:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:locale" content="en_US" />

        <meta name="twitter:site" content={twitterSiteAccount || ''} />

        <meta property="og:image:secure_url" content={ogImageLink} />
        <meta property="og:image" content={ogImageLink} />
        <meta name="twitter:card" content="summary_large_image" />
        <link
          data-react-helmet="true"
          rel="canonical"
          href={
            canonicalLink?.endsWith('/')
              ? process.env.GATSBY_SITE_URL + canonicalLink
              : process.env.GATSBY_SITE_URL + canonicalLink + '/' || '/'
          }
        ></link>

        <meta name="twitter:image" content={ogImageLink} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* Google tag (gtag.js) */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-322673101"
        ></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', 'AW-322673101');
          `}
        </script>
        <link rel="preload" href="//script.crazyegg.com/pages/data-scripts/0127/1415/site/magictask.io.json?t=1" as="fetch" fetchPriority="high" crossorigin />
        <link rel="preload" href="//script.crazyegg.com/pages/data-scripts/0127/1415/sampling/magictask.io.json?t=1" as="fetch" fetchPriority="high" crossorigin />
        <link rel="preload" href="//script.crazyegg.com/pages/abtests-scripts/0127/1415/magictask.io.css" as="style" fetchPriority="high" />
        <link href="//script.crazyegg.com/pages/abtests-scripts/0127/1415/magictask.io.css" rel="stylesheet" />
        {/* <script type="text/javascript" src="//script.crazyegg.com/pages/scripts/0127/1415.js" async="async" fetchPriority="high"></script> */}
        <script src="https://cdn.pagesense.io/js/magictask/826c1208c62c47ae9a6049d136110993.js"></script>
        <script>
          {`
            window.$zoho = window.$zoho || {};
            $zoho.salesiq = $zoho.salesiq || { ready: function() {} };
          `}
        </script>
        <script id="zsiqscript" src="https://salesiq.zohopublic.com/widget?wc=siq0c4883471b8678376cf905c7b7373a1d59a35c2996f1c5a1659e893149d6e608" defer></script>
        {/* Zoho CRM tracking script */}
        <script
          type="text/javascript"
          src="https://crm.zoho.com/crm/javascript/zcga.js"
        ></script>
      </Helmet>
    )
  }
}
